<template>
    <div class="add-event-type">
        <div style="display: flex; justify-content: space-between;align-items: center">
            <h2>Add Company</h2>
            <el-button type="primary" size="medium" @click="save()">Save</el-button>
        </div>
        <div slot="content">
            <div class="centered vue-loader" style="height: 350px" v-if="loading">
                <vue-loader></vue-loader>
            </div>
            <div v-else class="form p-b-0-label">
                <el-form ref="addBusCompany" :model="bus_company" :rules="formRules"
                         label-position="left"
                         class="newEventFormStyle">
                    <el-form-item label="Company name" prop="name">
                        <el-input v-model="bus_company.name"></el-input>
                    </el-form-item>
                    <el-form-item label="Phone number" prop="phone_number">
                        <el-input type="phone-number" v-model="bus_company.phoneNumber"></el-input>
                    </el-form-item>
                    <el-form-item label="User email" prop="email">
                        <el-input v-model="bus_company.userEmail"></el-input>
                    </el-form-item>
                    <el-form-item label="Company fb page" prop="companyFbPage">
                        <el-input v-model="bus_company.companyFbPage"></el-input>
                    </el-form-item>
                    <el-form-item label="Website" prop="website">
                        <el-input v-model="bus_company.website"></el-input>
                    </el-form-item>
                    <el-form-item label="Photo" prop="photo">
                        <div v-if="bus_company.photo === null">
                            <div @click="onEditPhoto"
                                 class="no-image-container">
                                <div class="no-image-contents">
                                    <div>Add image</div>
                                    <i class="el-icon-upload"/>
                                </div>
                            </div>
                        </div>

                        <div v-else
                             @click="onEditPhoto"
                             class="image-container">
                            <el-image
                                    style=" min-width: 170px;"
                                    :src="bus_company.photo">
                            </el-image>
                        </div>
                    </el-form-item>
                </el-form>

            </div>
        </div>

    </div>
</template>
<script>
    import {mapState} from 'vuex';
    import {LoaderIcon} from 'vue-feather-icons'
    import TravelService from '@/common/services/travel.service'
    import {uploadImageToImgur} from "../../common/services/image.upload.service";

    export default {
        name: "AddTravelCompany",
        components: {
            VueLoader: LoaderIcon
        },
        data() {
            return {
                loading: false,
                bus_company: {
                    name: null,
                    phoneNumber: null,
                    userEmail: null,
                    photo: null,
                    companyFbPage: "",
                    website: "",
                },
                formRules: {
                    name: {
                        required: true,
                        trigger: 'change',
                    },
                    phoneNumber: {
                        required: true,
                        trigger: 'change',
                    },
                    userEmail: {
                        required: true,
                        trigger: 'change',
                    },
                },
            }
        },
        computed: {
            ...mapState({
                user_email: state => state.user.user_email,
            })
        },
        methods: {
            onEditPhoto() {
                let input = document.createElement('input');
                input.type = 'file';
                input.click();
                input.onchange = e => {
                    let file = e.target.files[0];
                    this.onFileSelected(file);
                }
            },
            onFileSelected(image) {
                this.loading = true;
                let formData = new FormData();
                formData.append('image', image);
                uploadImageToImgur(image).then(res => {
                    this.bus_company.photo = res
                }).catch(er => {
                    console.log(er);
                    this.$notify.error({
                        title: `Failed to upload image`,
                        message: er.response.data.data.error
                    });
                }).finally(() => {
                    this.loading = false;
                });

            },
            save() {
                this.$refs['addBusCompany'].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        TravelService.addTravelCompany(this.bus_company).then(() => {
                            this.$notify.success({
                                title: `Bus`,
                                message: 'Successfully added bus company'
                            });
                            this.$emit('close')
                        }).catch(error => {
                            this.$notify.error({
                                title: `Failed to add bus company`,
                                message: error.response.data.message
                            });
                        }).finally(() => this.loading = false)
                    } else {
                        return false;
                    }
                })
            },
        }
    }
</script>
<style scoped lang="scss">
    .add-event-type {
        h3 {
            margin: 0;
        }

        padding: 20px;

        .add-buttons {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;

            .add-button {
                background-color: #efefef;
                border: 1px solid lightgray;
                width: 100%;
                padding: 10px 0;
                cursor: pointer;
            }
        }

        .form {
            height: 350px;

            .no-image-container {
                background-color: #f8f8f8;
                display: flex;
                width: 100%;
                height: 150px;
                cursor: pointer;

                .no-image-contents {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    flex-direction: column;
                    border-radius: 4px;
                }
            }

            .image-container {
                display: flex;
                justify-content: center;
                border: 1px solid #DCDFE6;
                border-radius: 4px;
                cursor: pointer;
            }

            .file-select {

            }

            .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }

            .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }

            .avatar {
                width: 178px;
                height: 178px;
                display: block;
            }

        }

        .footer-btn {
            display: flex;
            justify-content: flex-end;
        }

    }
</style>
